const outcomes = [
  {
    num: "01",
    title: "A working first version",
    text: "A prototype or product demonstration your team can see and test.",
  },
  {
    num: "02",
    title: "Real feedback",
    text:
      "Learning from users, stakeholders and the process itself—not assumptions alone.",
  },
  {
    num: "03",
    title: "A product roadmap",
    text:
      "A practical view of what to improve, integrate, launch or scale next.",
  },
  {
    num: "04",
    title: "Clear documentation",
    text:
      "Product, technical and implementation context your organisation can build on.",
  },
];

const owners = [
  {
    badge: "YOU",
    title: "Company Representative",
    text: "Provides context, validates the workflow and gives timely feedback.",
  },
  {
    badge: "LEAD",
    title: "Utiva Product Lead",
    text:
      "Owns problem understanding, product direction, communication and delivery quality.",
    lead: true,
  },
  {
    badge: "LAB",
    title: "Product Delivery Team",
    text:
      "Product, design, AI, software and data specialists selected around the challenge.",
  },
];

const BuildEvidenceSection = () => {
  return (
    <section className="apl-section">
      <div className="apl-shell">
        <div className="apl-evidence-grid">
          <div className="apl-evidence-copy apl-reveal">
            <div className="apl-eyebrow">What you leave with</div>
            <h2>A product—and evidence for what comes next.</h2>
            <p>
              The Lab does not end at a recommendation. It gives your
              organisation a concrete first version, learning from the build and
              a clearer path to implementation or scale.
            </p>
          </div>
          <div className="apl-evidence-list">
            {outcomes.map((outcome) => (
              <article
                className="apl-evidence-card apl-reveal"
                key={outcome.num}
              >
                <small>{outcome.num}</small>
                <h3>{outcome.title}</h3>
                <p>{outcome.text}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="apl-ownership">
          <div className="apl-ownership-head apl-reveal">
            <div className="apl-eyebrow">One challenge. One lab team.</div>
            <h2>Clear ownership from context to product.</h2>
            <p>
              Your team brings the business knowledge. Utiva brings the product
              leadership and specialists needed to build.
            </p>
          </div>
          <div className="apl-owner-grid">
            {owners.map((owner) => (
              <article
                className={`apl-owner-card${
                  owner.lead ? " apl-lead" : ""
                } apl-reveal`}
                key={owner.badge}
              >
                <strong>{owner.badge}</strong>
                <div>
                  <h3>{owner.title}</h3>
                  <p>{owner.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildEvidenceSection;
